export const CATALOG_DISH_TYPES = {
  SNACK: 'TYPE_SNACK',
  DRINK: 'TYPE_DRINK',
  MENU: 'TYPE_MENU'
};

export const CATALOG_STATUS = {
  PENDING: 'STATUS_PENDING',
  ACTIVE: 'STATUS_ACTIVE',
  BLOCKED: 'STATUS_BLOCKED'
};

export const CATALOG_RULES = {
  HIGHEST_MENU_PRICE: 'HIGHEST_MENU_PRICE'
};

export const MEAL_TYPES = [
  { value: 'LUNCH', label: 'Almuerzo' },
  { value: 'DINNER', label: 'Cena' },
  { value: 'BOTH', label: 'Almuerzo / Cena' }
];
